import { differenceInDays, parseISO } from 'date-fns'

import { dateReformatting } from './dateReformatting'

const formatToISO = (dateString: string): string => {
  const [day, month, year] = dateString.split('.')
  return `${year}-${month}-${day}`
}

export const dateDaysDifference = (dateFrom: string, dateTo: string): number => {
  const dateStringFrom = dateReformatting(dateFrom)
  const dateStringTo = dateReformatting(dateTo)

  const fromDate = parseISO(formatToISO(dateStringFrom))
  const toDate = parseISO(formatToISO(dateStringTo))

  return differenceInDays(toDate, fromDate)
}
